<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-cog"
            inline
            title="Pickup Management"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-data-table
              :headers="headers"
              :items="getlocs"
              :search="search"
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:item.action="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="blue darken-4"
                  @click="request_schedule(item)"
                >
                  <v-icon dark>
                    mdi-cog
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:item.reports="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="orange darken-4"
                  @click="request_reports(item)"
                >
                  <v-icon dark>
                    mdi-file
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'Wallets',

    data () {
      return {
        bal: '',
        search: '',
        valid: true,
        headers: [
          {
            sortable: true,
            text: 'Site ID',
            value: 'idnum'
          },
          { text: 'Group', value: 'group', align: 'left', sortable: false },
          { text: 'Schedule', value: 'freq', align: 'left', sortable: false },
          { text: 'Schedule Settings', value: 'action', align: 'center', sortable: false },
          { text: 'Pickup Report', value: 'reports', align: 'center', sortable: false },
          // { text: 'Pending Deposits', value: 'depintrans', align: 'center', sortable: false },
          // { text: 'DTS Deposits', value: 'dtsdeposits', align: 'center', sortable: false },
        ],
        items: [],
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,

        tabs: 0,
      }
    },
    timers: {
      log: { time: 300000, autostart: true, repeat: true }
    },
    computed: {
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents
        let schedules = this.$store.getters.getAllPickupSchedules
        console.log('all schedules ', schedules)
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          this.$log.debug('key value is ', key)
          let name = 'Unknown'
          let group = 'Unknown'
          let sitekey = ''
          let allowedusers = []
          let schedule = {
            safeid: '',
            schedule: '',
            siteid: '',
            sitekey: '',
            startdate: '',
            timestamp: ''
          }
          let freq = ''
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return true
            }
          })
          if (loc) {
            if (schedules) {
              schedule = schedules.find(entry => entry.sitekey === loc.sitekey)
              console.log('FOUND IT ', schedule)
              if (schedule) {
                freq = schedule.schedule
              } else {
                freq = 'please set'
              }
            }

            sitekey = loc.sitekey
            group = loc.group
            name = loc.sitename
            allowedusers = loc.allowedusers
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            this.$log.debug('looking for events for safe ', safeid)

            this.$log.debug('rej count is ', rejcount)

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            let status = 'N/A'
            let shop = {
              idnum: key,
              freq: freq,
              sitekey: sitekey,
              group: group,
              safeid: safeid,
              sitename: name
            }
            let stat = this.$store.getters.user.status
            let usrmail = this.$store.getters.user.email
            if (stat === 'admin' || stat === 'corporate' || this.$store.getters.user.institution) {
              if (!shop.safeid.includes('PostalSafe') && !shop.safeid.includes('Virtual')) {


                this.locations.push(shop)
              }
            }
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      },
      currentsafes () {
        this.$log.debug('SAFES ARE ', this.$store.getters.safesstatus)
        return this.$store.getters.safesstatus
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      }
    },
    created () {
      this.$store.dispatch('loadallpickupschedules')
      // this.$store.dispatch('resetsafetransactions')
      // this.items = this.$store.getters.safesstatus
    },
    methods: {
      log () {
        // this.$store.dispatch('loadsafes')
      },
      dts_enabled (item) {
        return false
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('MMMM Do, h:mm:ss')
      },

      request_transits (machine) {
        this.$log.debug('REQUEST ALERTS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$log.debug('machine id passed ', machine.safeid)
        this.$router.push({ path: '/Deposittransit/' + machine.safeid })
      },
      request_schedule (machine) {
        this.$router.push({ path: '/PickupSchedule/' + machine.safeid })
      },
      request_reports (machine) {
        this.$router.push({ path: '/PickupReports/' + machine.safeid })
      },
      reset () {
        this.wallet = ''
        this.dialog = false
      },
      onDecode (result) {
        // strip out crypto:address
        this.wallet.address = result
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
